import { HiUserGroup } from "react-icons/hi";
import { IoMdHome } from "react-icons/io";
import { MdAddIcCall } from "react-icons/md";

export const NavbarsData = [
  {
    id: 1,
    title: "home",
    path: "/",
  },
  // {
  //   id: 2,
  //   title: "expore events",
  //   path: "/event-management",
  // },
  // {
  //   id: 2,
  //   title: "help",
  //   subNavs: [
  //     {
  //       title: "FAQ",
  //       path: "/faq",
  //     },
  //     {
  //       title: "help center",
  //       path: "help-center",
  //     },
  //   ],
  // },
  {
    id: 2,
    title: "about us",
    path: "/about-us",
  },
  {
    id: 3,
    title: "contact",
    path: "/contact-us",
  },
];

export const teamMembers = [
  {
    name: "Rock William",
    title: "General Manager",
    image:
      "https://img.freepik.com/free-photo/handsome-bearded-guy-posing-against-white-wall_273609-20597.jpg?semt=ais_hybrid",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
      linkedin: "#",
    },
  },
  {
    name: "Jean KAKA",
    title: "Software Engineer",
    image:
      "https://img.freepik.com/free-photo/handsome-bearded-guy-posing-against-white-wall_273609-20597.jpg?semt=ais_hybrid",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
      linkedin: "#",
    },
  },
  {
    name: "Damian Murphy",
    title: "Business Development Manager",
    image:
      "https://img.freepik.com/free-photo/handsome-bearded-guy-posing-against-white-wall_273609-20597.jpg?semt=ais_hybrid",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
      linkedin: "#",
    },
  },
  {
    name: "Justine William",
    title: "Client Success Manager",
    image:
      "https://img.freepik.com/free-photo/handsome-bearded-guy-posing-against-white-wall_273609-20597.jpg?semt=ais_hybrid",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
      linkedin: "#",
    },
  },
];

export const footerData = [
  {
    id: 3,
    name: "About",
    icon: <HiUserGroup size={30} className="dark:text-white" />,
    path: "/about-us",
  },
  {
    id: 1,
    name: "Home",
    icon: <IoMdHome size={30} className="dark:text-white" />,
    path: "/",
  },
  {
    id: 4,
    name: "Contact",
    icon: <MdAddIcCall size={30} className="dark:text-white" />,
    path: "/contact-us",
  },
];

export const borderColors = [
  "border-red-500",
  "border-blue-500",
  "border-green-500",
  "border-purple-500",
  "border-yellow-500",
  "border-pink-500",
  "border-indigo-500",
  "border-teal-500",
];
